<template>
  <section :id class="container">
    <ClientOnly>
      <Countdown
        v-if="time !== null"
        :time="time"
        :show-days="showDays"
        :show-hours="showHours"
        :show-minutes="showMinutes"
        :show-seconds="showSeconds"
      />
      <div v-else-if="isEditing" class="text-red-500 font-bold">
        The entered date or time is invalid.
      </div>
    </ClientOnly>
  </section>
</template>

<script lang="ts" setup>
const { options, isEditing, index, siblings } = defineBlokkliFragment({
  name: 'countdown',
  label: 'Countdown',
  chunkName: 'rare',
  options: {
    date: {
      type: 'text',
      label: 'Date (Format: YYYY-MM-DD)',
      default: '',
    },
    time: {
      type: 'text',
      label: 'Time (Format: HH:MM)',
      default: '',
    },
    showDays: {
      type: 'checkbox',
      label: 'Show days',
      default: true,
    },
    showHours: {
      type: 'checkbox',
      label: 'Show hours',
      default: true,
    },
    showMinutes: {
      type: 'checkbox',
      label: 'Show minutes',
      default: true,
    },
    showSeconds: {
      type: 'checkbox',
      label: 'Show seconds',
      default: true,
    },
  },
})

const id = useParagraphAnchorId(index, siblings)

const now = useState('dateNow', () => Date.now())

const time = computed<number | null>(() => {
  // Return when date or time is missing.
  if (!options.value.date || !options.value.time) {
    return null
  }

  // Create date string and validate format.
  const targetDateString = `${options.value.date}T${options.value.time}`
  const targetDate = new Date(targetDateString)

  // Return if date is not valid.
  if (isNaN(targetDate.getTime())) {
    return null
  }

  // Calculate time difference.
  return Math.max(targetDate.getTime() - now.value, 0)
})

const showDays = computed(() => options.value.showDays)
const showHours = computed(() => options.value.showHours)
const showMinutes = computed(() => options.value.showMinutes)
const showSeconds = computed(() => options.value.showSeconds)
</script>
